import Dialog from '~/components/Dialog'
import TabularDataSchemaDisplay, {
  TabularDataSchema,
} from '../../utils/TabularDataSchemaDisplay'
import cs from './record_manual_passage_data_schemas_dialog.scss'

export type RecordManualPassageDataSchemasDialogProps = {
  isOpen: boolean
  onClose: () => void
}

const dataSchemas = {
  transfers_schema: {
    properties: [
      {
        name: 'plate_barcode',
        description: 'the barcode of the plate checked into the Monomer system',
        is_optional: false,
      },
      {
        name: 'well',
        description: 'the well on the plate that contains the culture',
        is_optional: false,
      },
      {
        name: 'parent_plate_barcode',
        description: 'the barcode of the parent plate',
        is_optional: false,
      },
      {
        name: 'parent_well',
        description: 'the parent well that the culture was transferred from',
        is_optional: false,
      },
    ],
    example:
      'plate_barcode\twell\tparent_plate_barcode\tparent_well\nPLATE_2A\tA1\tPLATE_1A\tA1\nPLATE_2A\tA2\tPLATE_1A\tA2\nPLATE_2A\tA3\tPLATE_1A\tA3\nPLATE_2A\tB1\tPLATE_1A\tB1\n',
  } as TabularDataSchema,
}

const RecordManualPassageDataSchemasDialog = ({
  isOpen,
  onClose,
}: RecordManualPassageDataSchemasDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className={cs.recordManualPassageDataSchemasDialog}
    >
      <div className={cs.title}>Accepted Data Format</div>
      <div className={cs.subtitle}>
        .csv and .tsv formats are supported. Please include the column names.
      </div>
      <div className={cs.optionTitle}>Schema</div>
      <TabularDataSchemaDisplay
        className={cs.schemaDisplay}
        schema={dataSchemas.transfers_schema}
      />
    </Dialog>
  )
}

export default RecordManualPassageDataSchemasDialog
